import type {
  AllStoreType,
  PresetStore,
  TImageStoreType,
} from "./imageEditor.type";

export const createPresetStore: TImageStoreType<PresetStore> = (set: any) => ({
  presets: [],
  setPreset: (preset: string) =>
    set((state: AllStoreType) => ({ ...state, preset })),
  initializePresets: () =>
    set((state: AllStoreType) => ({
      ...state,
      presets: [
        { id: "1", name: "Preset 1", type: "KID" },
        { id: "2", name: "Preset 2", type: "MEN" },
        { id: "3", name: "Preset 3", type: "WOMEN" },
      ],
    })),
});
